enum JobType {
	Permanent = 1,
}

export default JobType;